import React, { useState } from "react";
import { Zap, Upload, Loader2, Link2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatError } from "@/lib/api";
import { useLang } from "@/context/LangContext";

const OPTIONS = [
  { v: "manual", label: "يدوي", en: "Manual", Icon: Upload, hint: "ولّد المحتوى، ارفعه بنفسك، وأدخل أرقام الأداء", hintEn: "Generate content, upload it yourself, enter performance numbers" },
  { v: "super_rawaj", label: "سوبر رواج", en: "Super Rawaj", Icon: Zap, hint: "اربط حسابك، ولّد واعتمد — والنشر وسحب الأداء تلقائي", hintEn: "Connect your account, generate & approve — publishing and metrics are automatic" },
];

/** مبدّل واضح (radio) فوق الحملة: يدوي أم سوبر رواج — ويُحوَّل من المكان نفسه. */
export const ModeChoice = ({ addon, linked, onChosen }) => {
  const [busy, setBusy] = useState(false);
  const { t } = useLang();
  const mode = addon?.publish_mode || "manual";
  const choose = async (m) => {
    if (m === mode || busy) return;
    setBusy(true);
    try {
      await api.put("/social/publish-mode", { mode: m });
      toast.success(m === "super_rawaj" ? (linked ? "سوبر رواج يتكفّل بالنشر وسحب الأداء — ولّد واعتمد ثم جدوِل" : "اختر سوبر رواج — اربط حسابك أولاً ثم أنشئ الحملة") : "المسار اليدوي: ولّد، ارفع، وأدخل الأداء بنفسك");
      onChosen?.(m);
    } catch (e) { toast.error(formatError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <div className="rounded-2xl border border-border bg-background/40 p-3 flex items-center gap-4 flex-wrap" role="radiogroup" aria-label="طريقة التنفيذ" data-testid="mode-choice">
      <span className="text-sm font-bold flex items-center gap-2">{t("طريقة التنفيذ", "Execution mode")} {busy && <Loader2 className="w-3.5 h-3.5 animate-spin" />}</span>
      {OPTIONS.map(({ v, label, en, Icon, hint, hintEn }) => {
        const on = mode === v;
        return (
          <label key={v} className={`flex items-center gap-2 cursor-pointer rounded-xl border px-3 py-2 transition-colors ${on ? (v === "super_rawaj" ? "border-primary bg-primary/10" : "border-accent bg-accent/10") : "border-border hover:border-foreground/30"}`} data-testid={`mode-option-${v}`}>
            <input type="radio" name="publish-mode" value={v} checked={on} onChange={() => choose(v)} disabled={busy} className="accent-primary w-4 h-4" data-testid={`choose-${v === "manual" ? "manual" : "super"}`} />
            <Icon className={`w-4 h-4 ${v === "super_rawaj" ? "text-primary" : "text-accent"}`} />
            <span className="text-sm font-bold">{t(label, en)}</span>
            <span className="text-[11px] text-muted-foreground hidden sm:inline">— {t(hint, hintEn)}</span>
          </label>
        );
      })}
      {mode === "super_rawaj" && linked === false && (
        <span className="text-[11px] text-rose-400 font-bold flex items-center gap-1" data-testid="mode-choice-link-hint"><Link2 className="w-3 h-3" /> {t("اربط حسابك أولاً", "Connect your account first")}</span>
      )}
    </div>
  );
};
